<template>
  <v-text-field
    @input="(val) => $emit('input', val)"
    v-bind="$attrs"
    v-on="$listeners"
    :value="value"
    box
    hide-details
  />
</template>

<script>
export default {
  inheritAttrs: false,
  props: ['value'],
  data: () => ({}),
  methods: {},
}
</script>
